"use client";

import i18next, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "../constants";
import { getRegisteredResources, subscribeBundles } from "../registry";
import "../resources";

const I18NEXT_DEBUG = process.env.NEXT_PUBLIC_I18NEXT_DEBUG === "true";

void i18next.use(initReactI18next).init({
  resources: getRegisteredResources() as Resource,
  supportedLngs: [...SUPPORTED_LANGUAGES],
  fallbackLng: DEFAULT_LANGUAGE,
  lng: DEFAULT_LANGUAGE, // initial language; overridden by useT via changeLanguage()
  load: "languageOnly",
  defaultNS: "ui",
  interpolation: {
    escapeValue: false,
  },
  debug: process.env.NODE_ENV === "development" && I18NEXT_DEBUG,
});

// Bundles registered after init (e.g. a flow package) land on the live instance.
subscribeBundles((bundle) => {
  for (const [lng, data] of Object.entries(bundle.resources)) {
    if (data) i18next.addResourceBundle(lng, bundle.ns, data, true, true);
  }
});

export const i18n = i18next;
